import React from 'react'
import { GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid-pro'
import { Autocomplete, Stack, TextField } from '@mui/material'
import { stackGap } from '../../Constants&Theme/Spacing'
import RateCodeFilter from './RateCodeFilter'
import { facilityRateCodes } from './Pricebook'
import { useSearchParams } from 'react-router-dom'

function PricebookToolbar({
  facility,
  rateCodeFilter,
  setRateCodeFilter,
  category,
}: {
  facility: string
  rateCodeFilter: any
  setRateCodeFilter: any
  category: string
}) {
  const [, setSearchParams] = useSearchParams()
  return (
    <GridToolbarContainer sx={{ width: 1, p: 1 }}>
      <Stack
        width={1}
        direction={'row'}
        gap={stackGap.row}
      >
        <GridToolbarExport variant="outlined" />
        {category !== 'Shipper' && (
          <Autocomplete
            size={'small'}
            sx={{ maxWidth: 180 }}
            onChange={(event: any, newValue: any) => {
              setSearchParams((params) => {
                if (newValue) {
                  params.set('facility', newValue.id)
                } else {
                  params.delete('facility')
                }
                setRateCodeFilter({})
                return params
              })
            }}
            renderInput={(params) => (
              <TextField
                label={'Filter Billing Facility'}
                {...params}
              />
            )}
            value={facility ? { id: facility, label: facility } : null}
            fullWidth
            options={[
              { id: 'abr', label: 'ABR' },
              { id: 'garvan', label: 'Garvan/BTF' },
            ]}
          />
        )}
        <Stack
          direction={'row'}
          gap={stackGap.row}
          sx={{ ml: 'auto' }}
        >
          {Object.entries(facilityRateCodes)
            .filter(([key, val]) => val.facility === facility)
            .map(([key, val]) => {
              return (
                <RateCodeFilter
                  setRateCodeFilter={setRateCodeFilter}
                  rateCodeFilter={rateCodeFilter}
                  code={parseInt(key)}
                />
              )
            })}
        </Stack>
      </Stack>
    </GridToolbarContainer>
  )
}

export default PricebookToolbar
